import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-green-buildings',
  templateUrl: './green-buildings.component.html',
  styleUrls: ['./green-buildings.component.scss']
})
export class GreenBuildingsComponent implements OnInit {

  constructor(
    private router:Router,
    private titleService: Title
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle('MISK - Green Buildings');
  }

}
